// extracted by mini-css-extract-plugin
module.exports = {"ShapeA":"Description_ShapeA__11Sx_","Description":"Description_Description__23_Hs"};